import React, { useMemo, useState } from 'react';
import AdvancedFilters, { buildRansackSearch } from '@/components/admin/SysadminSPA/shared/AdvancedFilters';
import type { InitialFilter } from '@/components/admin/SysadminSPA/shared/AdvancedFilters';
import type { RansackSearch } from '@/components/admin/SysadminSPA/shared/filterTypes';
import SPADataTable from '@/components/admin/SysadminSPA/shared/SPADataTable';
import useFilterSearchParams from '@/components/admin/SysadminSPA/shared/useFilterSearchParams';
import getReferenceMaterialColumns from './referenceMaterialColumns';
import useContentReferenceMaterials from './useContentReferenceMaterials';
import useFilterOptions from './useFilterOptions';

const DEFAULT_FILTERS: InitialFilter[] = [
  { operator: 'eq', property: 'programs_id' },
];

const toRows = (filters: InitialFilter[]) => (
  filters.map((f, i) => ({ id: i, operator: f.operator, property: f.property, value: f.value ?? '' }))
);

// AIDEV-NOTE: Reference Materials table composed from shared SPA infrastructure.
// Layout: Filters → results/per-page bar → table. "Add Reference Material" is in the page header.
const ReferenceMaterialsTable = () => {
  const { initialFilters, syncRowsToURL } = useFilterSearchParams();
  const filtersToUse = initialFilters.length > 0 ? initialFilters : DEFAULT_FILTERS;
  const initialSearch = useMemo(() => buildRansackSearch(toRows(filtersToUse)), []); // eslint-disable-line
  const [ransackSearch, setRansackSearch] = useState<RansackSearch>(initialSearch);
  const { data, totalCount, isLoading, isFullyLoaded } = useContentReferenceMaterials(ransackSearch);
  const filterProperties = useFilterOptions();

  return (
    <div className="tw-mt-4">
      <AdvancedFilters
        initialFilters={filtersToUse}
        properties={filterProperties}
        onFilterChange={setRansackSearch}
        onRowsChange={syncRowsToURL}
      />

      <SPADataTable
        columns={getReferenceMaterialColumns()}
        data={data}
        emptyMessage="No reference materials found."
        isLoading={isLoading}
        loadingRows={20}
        loadingStatus={{ isFullyLoaded, loadedCount: data.length, totalCount }}
        pagination={{ defaultPageSize: 20, pageSizeOptions: [10, 20, 50, 100] }}
      />
    </div>
  );
};

export default ReferenceMaterialsTable;
